module.exports = __webpack_public_path__ + "img/zeitleiste-aufklappen-blau2.8c0148f7.svg";